import { useParams } from "react-router";
import { useEffect, useMemo, useRef, useState } from "react";
import { FetchWithAuth } from "digimaker-ui/util";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Alert, Button, Container, Overlay } from "react-bootstrap";
import { ContentLibrary } from "./ContentLibrary";
import useSiteStore from "../../store/useSiteStore";
import { DMEditorView } from "dmeditor";
import { Delete } from "digimaker-ui/actions";
import { convertObject } from "shared/src/widgets/util";
import { ShowPageUrl } from "../../components/ShowPageUrl";

export const MainContent = (props: {}) => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null as any);
  const { setCurrentContent, user } = useSiteStore();

  useEffect(() => {
    FetchWithAuth("content/get/" + params.id).then((resp: any) => {
      if (resp.error === false) {
        const content = resp.data;
        setContent(content);
        setCurrentContent(content);
      } else {
        setCurrentContent(null);
        setContent(null);
      }
    });
  }, [params.id]);

  const jumpTo = (id: any) => {
    navigate(`/fulledit/${params.id}`);
  };

  const canDelete = useMemo(() => {
    if (content) {
      const roles = user.roles;
      if (roles.includes("bridge-admin")) {
        return true;
      } else {
        return content.metadata.author === user.id;
      }
    }
    return false;
  }, [content]);

  if (!content) {
    return <div>...</div>;
  }

  return (
    <div>
      {content && ["page", "site"].includes(content.metadata.contenttype) && (
        <div>
          <div className="text-right">
            <Link
              to={
                content.link
                  ? "/website/edit/" + params.id
                  : "/fulledit/" + params.id
              }
            >
              <Button
                variant="outline-link"
                size="sm"
                onClick={() => jumpTo(params.id)}
              >
                <i className="bi bi-pencil"></i> Rediger side
              </Button>
            </Link>
            <ShowPageUrl content={content} />
            {content.metadata.contenttype !== "site" && canDelete && (
              <Delete
                fromview="content"
                params={{
                  content: content,
                  afterAction: () => {
                    navigate("/website");
                  },
                }}
              />
            )}
          </div>
          <div
            className={
              "preview-dmeditor contenttype-" + content.metadata.contenttype
            }
          >
            <div className="dmeditor-container">
              <DMEditorView data={convertObject(content.full_body || [])} />
            </div>

            {content.link && (
              <div style={{ padding: 20 }}>
                <label>Lenke:</label>
                <div>
                  <a href={content.link} target="_blank">
                    {content.metadata.name}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {content &&
        content.metadata.contenttype === "folder" &&
        [
          "article",
          "image",
          "file",
          "template",
          "event",
          "annual_report",
          "link",
          "block",
        ].includes(content.folder_type.value) && (
          <ContentLibrary
            key={content.location.id}
            content={content}
            categoryID={
              searchParams.has("tab")
                ? parseInt(searchParams.get("tab") as string)
                : undefined
            }
          />
        )}
    </div>
  );
};
